// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last ADD : REMOVE UNUSED FUNCTION
// MODFIED DATA : 02-09-2025

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/*************** SEARCH MEMBER AUTO LOAN START *************** */
export const searchMemberAutoLoan = (listData: any) => {
	const data = {
		SearchAutoLoanToken: listData,
	};
	const url = `${API_URL}searchAutoLoanMember`;
	return makeApiCall(url, data);
};
/*************** SEARCH MEMBER AUTO LOAN END *************** */

/*************** CREATE MEMBER AUTO LOAN BASIC START *************** */
export const addAutoLoanMemberBasic = (createData: any) => {
	const data = {
		CreateAutoLoanMemberBasicToken: createData,
	};
	const url = `${API_URL}addAutoLoanMemberBasicDetails`;
	return makeApiCall(url, data);
};
/*************** CREATE MEMBER AUTO LOAN BASIC END *************** */

/*************** CREATE MEMBER AUTO LOAN ADDRESS START *************** */
export const addAutoLoanMemberAddress = (createData: any) => {
	const data = {
		CreateAutoLoanMemberAddressToken: createData,
	};
	const url = `${API_URL}addAutoLoanMemberAddressDetails`;
	return makeApiCall(url, data);
};
/*************** CREATE MEMBER AUTO LOAN ADDRESS END *************** */

/*************** CREATE MEMBER AUTO LOAN BANK START *************** */
export const addAutoLoanMemberBank = (createData: any) => {
	const data = {
		CreateAutoLoanMemberBankToken: createData,
	};
	const url = `${API_URL}addAutoLoanMemberBankDetails`;
	return makeApiCall(url, data);
};
/*************** CREATE MEMBER AUTO LOAN BANK END *************** */

/*************** CREATE MEMBER AUTO LOAN IMAGE START *************** */
export const addAutoLoanMemberImage = (createData: any) => {
	const data = {
		CreateAutoLoanMemberImagesToken: createData,
	};
	const url = `${API_URL}addAutoLoanMemberImageDetails`;
	return makeApiCall(url, data);
};
/*************** CREATE MEMBER AUTO LOAN IMAGE END *************** */

/*************** CREATE MEMBER AUTO LOAN COAPPLICANT START *************** */
export const addAutoLoanMemberCoapplicant = (createData: any) => {
	const data = {
		CreateAutoLoanCoApplicantBasicDetailsToken: createData,
	};
	const url = `${API_URL}addAutoLoanCoApplicantBasicDetails`;
	return makeApiCall(url, data);
};
/*************** CREATE MEMBER AUTO LOAN COAPPLICANT END *************** */

/*************** CREATE MEMBER AUTO LOAN COAPPLICANT DOCUMENT START *************** */
export const addAutoLoanMemberCoapplicantDocument = (createData: any) => {
	const data = {
		CreateAutoLoanCoApplicantImagesToken: createData,
	};
	const url = `${API_URL}addAutoLoanCoApplicantImageDetails`;
	return makeApiCall(url, data);
};
/*************** CREATE MEMBER AUTO LOAN COAPPLICANT DOCUMENT END *************** */

/*************** CREATE MEMBER AUTO LOAN VEHICLE START *************** */
export const addAutoLoanMemberVehicle = (createData: any) => {
	const data = {
		CreateAutoLoanMemberVehicleToken: createData,
	};
	const url = `${API_URL}addAutoLoanMemberVehicleDetails`;
	return makeApiCall(url, data);
};
/*************** CREATE MEMBER AUTO LOAN VEHICLE END *************** */

/*************** CREATE MEMBER AUTO LOAN VEHICLE DOCUMENT START *************** */
export const addAutoLoanMemberVehicleDocument = (createData: any) => {
	const data = {
		CreateAutoLoanMemberVehicleDocumentToken: createData,
	};
	const url = `${API_URL}addAutoLoanMemberVehicleDocumentDetails`;
	return makeApiCall(url, data);
};
/*************** CREATE MEMBER AUTO LOAN VEHICLE DOCUMENT END *************** */

/*************** CREATE MEMBER AUTO LOAN BUSINESS START *************** */
export const addAutoLoanMemberBusiness = (createData: any) => {
	const data = {
		CreateAutoLoanMemberBusinessToken: createData,
	};
	const url = `${API_URL}addAutoLoanMemberBusinessDetails`;
	return makeApiCall(url, data);
};
/*************** CREATE MEMBER AUTO LOAN BUSINESS END *************** */

/*************** CREATE MEMBER AUTO LOAN BUSINESS IMAGE START *************** */
export const addAutoLoanMemberBusinessImage = (createData: any) => {
	const data = {
		CreateAutoLoanMemberBusinessImageToken: createData,
	};
	const url = `${API_URL}addAutoLoanMemberBusinessImageDetails`;
	return makeApiCall(url, data);
};
/*************** CREATE MEMBER AUTO LOAN BUSINESS IMAGE END *************** */

/*************** CREATE MEMBER AUTO LOAN AUTO LOAN INDEX START *************** */
export const addAutoLoanMemberAutoLoanIndex = (createData: any) => {
	const data = {
		CreateAutoLoanIndexDetailsToken: createData,
	};
	const url = `${API_URL}addAutoLoanIndexDetails`;
	return makeApiCall(url, data);
};
/*************** CREATE MEMBER AUTO LOAN AUTO LOAN INDEX END *************** */

/*************** FETCH AUTO LOAN PROPOSAL START *************** */
export const fetchAutoLoanIndexList = (fetchData: any) => {
	const data = {
		fetchAutoLoanProposalToken: fetchData,
	};
	const url = `${API_URL}fetchAutoLoanproposallist`;
	return makeApiCall(url, data);
};
/*************** FETCH AUTO LOAN PROPOSAL END *************** */

/*************** FETCH AUTO LOAN PROPOSAL DETAIL START *************** */
export const getParticularAutoLoan = (getData: any) => {
	const data = {
		GetPaticularAutoLoanProposalToken: getData,
	};
	const url = `${API_URL}getParticularAutoLoanproposallist`;
	return makeApiCall(url, data);
};
/*************** FETCH AUTO LOAN PROPOSAL DETAIL END *************** */

/*************** APPROVE AUTO LOAN PROPOSAL DETAIL START *************** */
export const approveAutoLoan = (approveData: any) => {
	const data = {
		approveAutoLoanProposalToken: approveData,
	};
	const url = `${API_URL}approveAutoLoanproposal`;
	return makeApiCall(url, data);
};
/*************** APPROVE AUTO LOAN PROPOSAL DETAIL END *************** */

/*************** REVERT AUTO LOAN PROPOSAL DETAIL START *************** */
export const revertAutoLoan = (revertData: any) => {
	const data = {
		revertAutoLoanProposalToken: revertData,
	};
	const url = `${API_URL}revertAutoLoanproposal`;
	return makeApiCall(url, data);
};
/*************** REVERT AUTO LOAN PROPOSAL DETAIL END *************** */

/*************** DELETE AUTO LOAN PROPOSAL DETAIL START *************** */
export const deleteAutoLoan = (deleteData: any) => {
	const data = {
		deleteAutoLoanProposalToken: deleteData,
	};
	const url = `${API_URL}deleteAutoLoanproposal`;
	return makeApiCall(url, data);
};
/*************** DELETE AUTO LOAN PROPOSAL DETAIL END *************** */

/*************** GET DEALER LIST START *************** */
export const getdealerList = (fetchData: any) => {
	const data = {
		GetDealerListToken: fetchData,
	};
	const url = `${API_URL}fetchDealerListDetail`;
	return makeApiCall(url, data);
};
/*************** GET DEALER LIST END *************** */

/*************** GET PERMANT PINCODE START *************** */
export const getPermantPincode = (fetchData: any) => {
	const data = {
		FetchPincodeListToken: fetchData,
	};
	const url = `${API_URL}FetchPincodeDetails`;
	return makeApiCall(url, data);
};
/*************** GET PERMANT PINCODE END *************** */

/*************** CHECK AUTO LOAN MANDATORY DETAILS START *************** */
export const checkAutoLoanMandatoryDetails = (fetchData: any) => {
	const data = {
		AutoLoanMandatoryFieldsToken: fetchData,
	};
	const url = `${API_URL}autocheckMandatoryFields`;
	return makeApiCall(url, data);
};
/*************** CHECK AUTO LOAN MANDATORY DETAILS END *************** */

/*************** UPDATE MEMBER AUTO LOAN INDEX DETAILS START *************** */
export const updateMemberAutoLoanIndexDetails = (updateData: any) => {
	const data = {
		UpdateAutoLoanIndexDetailsToken: updateData,
	};
	const url = `${API_URL}updateAutoLoanIndexDetails`;
	return makeApiCall(url, data);
};
/*************** UPDATE MEMBER AUTO LOAN INDEX DETAILS END *************** */
